export const ItemTypes = {
  CARD: "CARD",
};
